import { FunctionComponent, useEffect } from 'react';

import { useGenerateImageFromCharts } from 'PDF/hooks/useGenerateImageFromCharts';

import { ChartWithStackedBars } from './ChartWithStackedBars';
import { IChartWithStackedBars } from '../types';

interface IChartWithStackedBarsWrapper {
  info: IChartWithStackedBars;
  aspectRatio?: number;
  isSmall?: boolean;
  withBarTopLabels?: boolean;
  withBarInsideLabels?: boolean;
  updateState: (title: string, src: string) => void;
  axiosInPercentageProps?: {
    min: number;
    max: number;
    stepSize: number;
  };
}

export const ChartWithStackedBarsWrapper = ({
  aspectRatio,
  info,
  isSmall,
  withBarTopLabels,
  withBarInsideLabels,
  updateState,
  axiosInPercentageProps,
}: IChartWithStackedBarsWrapper) => {
  const [chartPortal, chartImgSrc] = useGenerateImageFromCharts(ChartWithStackedBars as FunctionComponent, {
    aspectRatio,
    isSmall,
    info,
    withBarTopLabels,
    withBarInsideLabels,
    axiosInPercentageProps,
  });

  useEffect(() => {
    if (chartImgSrc) {
      updateState(info.title, chartImgSrc);
    }
  }, [chartImgSrc]);

  return <>{chartPortal}</>;
};
